import script from "./TabBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=ts"

import "./TabBar.vue?vue&type=style&index=0&id=6d33ec90&lang=less"
import "./TabBar.vue?vue&type=style&index=1&id=6d33ec90&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d33ec90"]])

export default __exports__